import React from "react";

function Error() {
  return <div>ERORR! Page not Found!</div>;
}

export default Error;
